document.addEventListener('DOMContentLoaded', function() {
    var menuItems = document.querySelectorAll('.lookinner .stylelookstyle');
    
    var allStyleLookData = document.querySelectorAll('.card_product_main_wrap .lookstyledata1');
    allStyleLookData.forEach(function(item) {
      item.querySelectorAll('.card__inner a.media').forEach(function(media) {
        media.style.cursor = 'no-drop';
      });
      item.querySelectorAll('.product-card-wrapper .quick-add .quick-add__submit').forEach(function(submit) {
        submit.style.cursor = 'no-drop';
      });
    });

    var activeItems = document.querySelectorAll('.card_product_main_wrap .lookstyledata1.active');
    activeItems.forEach(function(item) {
      item.querySelectorAll('.card__inner a.media').forEach(function(media) {
        media.style.cursor = 'pointer';
      });
      item.querySelectorAll('.product-card-wrapper .quick-add .quick-add__submit').forEach(function(submit) {
        submit.style.cursor = 'pointer';
      });
    });

    document.body.addEventListener('click', function(event) {
      if (event.target.matches('.lookinner .stylelookstyle')) {

        var tab_id = event.target.dataset.id;

        document.querySelectorAll('.lookinner .stylelookstyle').forEach(function(item) {
          item.classList.remove('active');
        });
        document.querySelectorAll('.card_product_main_wrap .lookstyledata1').forEach(function(item) {
          item.classList.remove('active');
          item.style.opacity = '0.5';
          item.style.cursor = 'no-drop';
          item.querySelectorAll('.card__inner a.media').forEach(function(media) {
            media.style.cursor = 'no-drop';
          });
          item.querySelectorAll('.product-card-wrapper .quick-add .quick-add__submit').forEach(function(submit) {
            submit.style.cursor = 'no-drop';
          });
        });

        event.target.classList.add('active');
        var activeContent = document.getElementById(tab_id);
        if (activeContent) {
          activeContent.classList.add('active');
          activeContent.style.opacity = '1';
          activeContent.style.cursor = 'pointer';

          activeContent.querySelectorAll('.card__inner a.media').forEach(function(media) {
            media.style.cursor = 'pointer';
          });
          activeContent.querySelectorAll('.product-card-wrapper .quick-add .quick-add__submit').forEach(function(submit) {
            submit.style.cursor = 'pointer';
          });
        }
      }
    });
});